import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Sponsors from '../components/Sponsors';
import '../assets/styles/containers/SimpleSection.sass';

class SimpleSection extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
      banner: 62,
    }
  }
  
  componentDidMount() {
    const {slug} = this.props.match.params;
    this.getBanner(slug);
    this.getData(slug);
  }
  
  componentWillReceiveProps(nextProps) {
    const {slug} = this.props.match.params;
    if(slug !== nextProps.match.params.slug) {
      this.getBanner(nextProps.match.params.slug);
      this.getData(nextProps.match.params.slug);
    }
  }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/general/adventures/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({data: res});
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }

  getBanner(slug) {
    switch (slug) {
      case 'custom-mtb-tour':
        return this.setState({banner: 62});
      case 'custom-road-tour':
        return this.setState({banner: 65});
      default:
        return this.setState({banner: 62});
    }
  }

  render() {
    const {data, banner} = this.state;
    const {content, sponsors} = data;

    return (
      <Layout>
        <>
          <Banner id={banner} city="custom" thumb="logo_adventures.png"/>
          <div className="row content-min-height">
            {ReactHtmlParser(content?.content_es)}
          </div>
          {sponsors && (
            <Sponsors
              items={sponsors}
              city="home"
            />
          )}
        </>
      </Layout>
    );

  }
}

export default SimpleSection;
